import { render } from "./DashboardVehicles.vue?vue&type=template&id=db86e4f0&scoped=true"
import script from "./DashboardVehicles.vue?vue&type=script&lang=js"
export * from "./DashboardVehicles.vue?vue&type=script&lang=js"

import "./DashboardVehicles.vue?vue&type=style&index=0&id=db86e4f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db86e4f0"]])

export default __exports__